//State
export const SET_REQUEST_STARTED       = 'REQUEST_STARTED';
export const SET_REQUEST_ENDED         = 'REQUEST_ENDED';
export const SET_BURGER_STATE          = 'SET_BURGER_STATE';
export const SET_BURGER_ANIMATE        = 'SET_BURGER_ANIMATE';
export const SET_CURRENT_POPUP         = 'SET_CURRENT_POPUP';
export const REMOVE_CURRENT_POPUP      = 'REMOVE_CURRENT_POPUP';
export const SET_DEVICE_STATE          = 'SET_DEVICE_STATE';

//Config
export const SET_TRANSLATIONS          = 'SET_TRANSLATIONS';
export const SET_WEB_MODE              = 'SET_WEB_MODE';
export const SET_ABOUT                 = 'SET_ABOUT';
export const SET_MEDIA_URL             = 'SET_MEDIA_URL';
export const SET_RECOMMENDATIONS       = 'SET_RECOMMENDATIONS';
export const SET_PEEPS_SCORE           = 'SET_PEEPS_SCORE';
export const SET_DATE                  = 'SET_DATE';
export const SET_EASY_SEARCH           = 'SET_EASY_SEARCH';
export const SET_FLOW_INFORMATION      = 'SET_FLOW_INFORMATION';
export const SET_LEASING_COMPANIES     = 'SET_LEASING_COMPANIES';
export const SET_EASY_BUY              = 'SET_EASY_BUY';
export const SET_FOOTER_ITEM           = 'SET_FOOTER_ITEM';
export const SET_MENU                  = 'SET_MENU';
export const SET_CAR_CATEGORIES        = 'SET_CAR_CATEGORIES';
export const SET_PRICE_STAIRS          = 'SET_PRICE_STAIRS';
export const SET_SORT_TYPES            = 'SET_SORT_TYPES';
export const SET_CAR_BANNERS           = 'SET_CAR_BANNERS';
export const SET_ABOUT_PAGE            = 'SET_ABOUT_PAGE';
export const SET_HOW_DOES_IT_WORK      = 'SET_HOW_DOES_IT_WORK';
export const SET_ROUTES_TABLE          = 'SET_ROUTES_TABLE';
export const SET_FAQ                   = 'SET_FAQ';
export const SET_CITIES                = 'SET_CITIES';
export const SET_PREPAY                = 'SET_PREPAY';

//Data
export const SET_USER                  = 'SET_USER';
export const SET_CATEGORIES            = 'SET_CATEGORIES';
export const SET_RESULTS               = 'SET_RESULTS';
export const SET_AUTOCOMPLETE_RESULTS  = 'SET_AUTOCOMPLETE_RESULTS';
export const SET_MANUFACTURERS         = 'SET_MANUFACTURERS';
export const SET_CARS                  = 'SET_CARS';
export const SET_SEARCH                = 'SET_SEARCH';
export const SET_REFRESH               = 'SET_REFRESH';
export const SET_CAR                   = 'SET_CAR';
export const GET_LEAD                  = 'GET_LEAD';
export const GET_SMS_VALIDATION        = 'GET_SMS_VALIDATION';
export const SET_ORDER_DETAILS         = 'SET_ORDER_DETAILS';
export const SET_CONTENT_PAGE          = 'SET_CONTENT_PAGE';
export const SET_FAVORITES             = 'SET_FAVORITES';
export const SET_CG                    = 'SET_CG';
export const SET_APPOINTMENTS          = 'SET_APPOINTMENTS';
export const SET_SMS                   = 'SET_SMS';
export const SET_SUMMARY               = 'SET_SUMMARY';
export const SET_META_TAGS             = 'SET_META_TAGS';
export const SET_RESULTS_FILTERS       = 'SET_RESULTS_FILTERS';